/* Lumelie theme — interactions. Vanilla JS, event delegation, no dependencies. */
(() => {
  const L = window.Lumelie || {};
  const R = L.routes || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const isMobile = () => window.matchMedia('(max-width: 959px)').matches;

  /* ---------- Helpers ---------- */
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  const money = cents => {
    const fmt = L.moneyFormat || '€{{amount_with_comma_separator}}';
    const n = (cents / 100).toFixed(2);
    const [a, b] = n.split('.');
    const dots = a.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return a;
      if (k === 'amount_with_comma_separator') return dots + ',' + b;
      if (k === 'amount_no_decimals_with_comma_separator') return dots;
      return a.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + b;
    });
  };
  let toastT;
  const toast = msg => {
    const el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-shown');
    clearTimeout(toastT); toastT = setTimeout(() => el.classList.remove('is-shown'), 2600);
  };
  const locks = new Set();
  const lock = (id, on) => { on ? locks.add(id) : locks.delete(id); document.body.classList.toggle('lm-locked', locks.size > 0); };
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------- Announcement rotator (mobile) ---------- */
  const ann = $$('[data-announce] .lm-announce__mob span');
  if (ann.length > 1) {
    let i = 0;
    setInterval(() => { ann[i].classList.remove('is-active'); i = (i + 1) % ann.length; ann[i].classList.add('is-active'); }, 4000);
  }

  /* ---------- Header panels (age mega menu + search) ---------- */
  const scrim = $('[data-panel-scrim]');
  let openPanel = null;
  const setPanel = name => {
    openPanel = name;
    $$('[data-panel]').forEach(p => p.classList.toggle('is-open', p.dataset.panel === name));
    $$('[data-panel-trigger]').forEach(b => b.setAttribute('aria-expanded', b.dataset.panelTrigger === name ? 'true' : 'false'));
    if (scrim) scrim.classList.toggle('is-open', !!name);
  };
  $$('[data-panel-trigger]').forEach(btn => {
    btn.addEventListener('click', () => setPanel(openPanel === btn.dataset.panelTrigger ? null : btn.dataset.panelTrigger));
    btn.addEventListener('mouseenter', () => { if (!isMobile()) setPanel(btn.dataset.panelTrigger); });
  });
  $$('[data-panel-leave]').forEach(a => a.addEventListener('mouseenter', () => { if (openPanel && openPanel !== 'search') setPanel(null); }));
  const header = $('[data-header]');
  if (header) header.addEventListener('mouseleave', () => { if (openPanel && openPanel !== 'search') setPanel(null); });
  if (scrim) scrim.addEventListener('click', () => setPanel(null));

  /* Predictive search */
  const results = $('[data-search-results]');
  const defaultResults = results ? results.innerHTML : '';
  const searchTitle = $('[data-search-title]');
  const searchAll = $('[data-search-all]');
  let searchCtrl;
  const runSearch = debounce(async q => {
    if (!results) return;
    if (searchAll) searchAll.href = `${R.search}?type=product&q=${encodeURIComponent(q)}`;
    if (!q) { results.innerHTML = defaultResults; if (searchTitle) searchTitle.textContent = 'Populaire producten'; return; }
    if (searchTitle) searchTitle.textContent = `Producten voor “${q}”`;
    searchCtrl && searchCtrl.abort(); searchCtrl = new AbortController();
    try {
      const res = await fetch(`${R.predictive}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`, { signal: searchCtrl.signal });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const out = $('[data-predictive-results]', doc);
      if (out) results.innerHTML = out.innerHTML;
    } catch (e) { /* aborted */ }
  }, 220);
  $$('[data-search-input]').forEach(input => {
    input.addEventListener('focus', () => setPanel('search'));
    input.addEventListener('input', () => { setPanel('search'); $$('[data-search-input]').forEach(o => { if (o !== input) o.value = input.value; }); runSearch(input.value.trim()); });
  });
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-search-term]'); if (!t) return;
    const input = $$('[data-search-input]').find(i => i.offsetParent) || $('[data-search-input]');
    if (input) { input.value = t.dataset.searchTerm; input.focus(); runSearch(t.dataset.searchTerm); }
  });

  /* ---------- Drawers ---------- */
  const openDrawer = id => {
    const d = document.getElementById(id); if (!d) return;
    setPanel(null);
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    const s = $(`[data-drawer-scrim="${id}"]`); if (s) s.classList.add('is-open');
    lock(id, true);
    const f = $('button, a', d); if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
  };
  const isCartPage = document.body.classList.contains('template-cart');
  const closeDrawer = id => {
    const d = document.getElementById(id); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    const s = $(`[data-drawer-scrim="${id}"]`); if (s) s.classList.remove('is-open');
    lock(id, false);
    /* /cart has no page of its own: closing the slide cart leaves the cart URL */
    if (isCartPage && id === 'CartDrawer' && !L.isDesignMode) {
      const ref = document.referrer;
      if (ref && new URL(ref).origin === location.origin && !/\/cart(\?|$)/.test(new URL(ref).pathname) && history.length > 1) history.back();
      else location.href = R.root;
    }
  };
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.drawerOpen); return; }
    const c = e.target.closest('[data-drawer-close]');
    if (c) { const d = c.closest('[data-drawer]'); if (d) closeDrawer(d.id); return; }
    const s = e.target.closest('[data-drawer-scrim]');
    if (s) closeDrawer(s.dataset.drawerScrim);
  });

  /* ---------- Accordions ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-acc-toggle]'); if (!b) return;
    const acc = b.closest('[data-acc]'); if (!acc) return;
    const group = acc.closest('[data-acc-group]');
    const open = !acc.classList.contains('is-open');
    if (group && open) $$('[data-acc]', group).forEach(a => { if (a !== acc && a.parentElement === acc.parentElement) { a.classList.remove('is-open'); const t = $('[data-acc-toggle]', a); if (t) t.setAttribute('aria-expanded', 'false'); } });
    acc.classList.toggle('is-open', open);
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Sliders ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-slider-prev], [data-slider-next]'); if (!b) return;
    const wrap = b.closest('[data-slider-wrap]') || b.closest('section'); if (!wrap) return;
    const el = $('[data-slider]', wrap); if (!el) return;
    const dir = b.hasAttribute('data-slider-next') ? 1 : -1;
    const first = el.firstElementChild;
    const step = first && el.clientWidth < 500 ? first.offsetWidth + 10 : el.clientWidth * 0.8;
    el.scrollBy({ left: dir * step, behavior: 'smooth' });
  });
  const initDots = (root = document) => {
    $$('[data-dots-slider]', root).forEach(w => {
      const el = $('[data-slider]', w), dots = $('[data-dots]', w);
      if (!el || !dots || dots.childElementCount) return;
      const items = Array.from(el.children);
      if (items.length < 2) return;
      items.forEach((_, n) => {
        const d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Review ' + (n + 1));
        if (!n) d.classList.add('is-active');
        d.addEventListener('click', () => el.scrollTo({ left: items[n].offsetLeft - el.offsetLeft - 20, behavior: 'smooth' }));
        dots.appendChild(d);
      });
      el.addEventListener('scroll', debounce(() => {
        const w0 = items[0].offsetWidth + 10, n = Math.round(el.scrollLeft / w0);
        Array.from(dots.children).forEach((d, i) => d.classList.toggle('is-active', i === n));
      }, 60), { passive: true });
    });
  };
  initDots();

  /* ---------- Modals ---------- */
  const FOCUSABLE = 'a[href], button:not([disabled]):not([hidden]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const focusables = el => $$(FOCUSABLE, el).filter(x => x.offsetParent !== null || x === document.activeElement);
  const focusInModal = m => {
    const box = $('[data-modal-box]', m) || $('.lm-modal__box', m) || m;
    const target = $('[data-modal-focus]', box) || focusables(box).find(x => !x.matches('[data-modal-close]')) || $('[data-modal-close]', box) || box;
    if (target === box && !box.hasAttribute('tabindex')) box.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  };
  const openModal = (m, opener) => {
    if (!m) return;
    setPanel(null);
    m._opener = opener || (document.activeElement !== document.body ? document.activeElement : null);
    m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); lock(m.id || 'modal', true);
    requestAnimationFrame(() => focusInModal(m));
  };
  const closeModal = m => {
    if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); lock(m.id || 'modal', false);
    m.dispatchEvent(new CustomEvent('lm:closed'));
    const o = m._opener; m._opener = null;
    if (o && o.isConnected && typeof o.focus === 'function') o.focus({ preventScroll: true });
  };
  L.focusInModal = focusInModal;
  /* Keep Tab focus inside the open modal */
  document.addEventListener('keydown', e => {
    if (e.key !== 'Tab') return;
    const open = $$('[data-modal].is-open'); if (!open.length) return;
    const m = open[open.length - 1], box = $('[data-modal-box]', m) || $('.lm-modal__box', m) || m;
    const items = focusables(box); if (!items.length) { e.preventDefault(); box.focus(); return; }
    const first = items[0], last = items[items.length - 1];
    if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', e => {
    const c = e.target.closest('[data-modal-close]');
    if (c) { closeModal(c.closest('[data-modal]')); return; }
    const o = e.target.closest('[data-modal-open]');
    if (o) { e.preventDefault(); openModal(document.getElementById(o.dataset.modalOpen)); return; }
    if (e.target.matches('[data-modal]')) closeModal(e.target);
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    setPanel(null);
    $$('[data-modal].is-open').forEach(closeModal);
    $$('[data-drawer].is-open').forEach(d => closeDrawer(d.id));
  });

  /* ---------- Cart ---------- */
  const cartSectionId = () => {
    const d = $('[data-cart-drawer]'); if (!d) return null;
    const w = d.closest('.shopify-section'); return w ? w.id.replace('shopify-section-', '') : null;
  };
  const updateCounts = count => {
    $$('[data-cart-count]').forEach(b => {
      const grew = count > (parseInt(b.textContent, 10) || 0);
      b.textContent = count; b.hidden = count === 0;
      if (grew) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }
    });
    $$('[data-cart-count-inline]').forEach(b => { b.textContent = count; });
  };
  /* Holiday deadline in the cart: first message whose "until" date (inclusive, local time) hasn't passed. */
  const holiday = (root = document) => {
    const today = new Date(); today.setHours(0, 0, 0, 0);
    $$('[data-holiday]', root).forEach(el => {
      const at = (k, n) => el.getAttribute(`data-${k}-${n}`) || '';
      const pick = [1, 2].find(n => { const d = new Date(at('until', n) + 'T00:00:00'); return at('text', n) && !isNaN(d) && today <= d; });
      el.textContent = pick ? at('text', pick) : ''; el.hidden = !pick;
    });
  };
  holiday();

  /* Delivery window (under the ATC and in the cart): today + min..max calendar days */
  const deliv = (root = document) => {
    const addDays = n => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
    const lang = document.documentElement.lang || 'nl', clean = s => s.replace(/\./g, '');
    const full = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' });
    const short = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric' });
    $$('[data-deliv]', root).forEach(el => {
      const out = $('[data-deliv-date]', el); if (!out) return;
      const d1 = addDays(+el.dataset.min || 2), d2 = addDays(+el.dataset.max || 3);
      /* Same month: "di 3 – do 5 nov"; otherwise both dates get their month. */
      out.textContent = `${clean((d1.getMonth() === d2.getMonth() ? short : full).format(d1))} – ${clean(full.format(d2))}`;
    });
  };
  const renderCart = (sections) => {
    const id = cartSectionId(); if (!id || !sections || !sections[id]) return;
    const wrap = document.getElementById('shopify-section-' + id);
    const wasOpen = $('[data-cart-drawer]').classList.contains('is-open');
    const scrollTop = ($('[data-cart-drawer] .lm-drawer__body') || {}).scrollTop || 0;
    const doc = new DOMParser().parseFromString(sections[id], 'text/html');
    const fresh = $('.shopify-section', doc) || doc.body;
    wrap.innerHTML = fresh.innerHTML;
    if (wasOpen) {
      const d = $('[data-cart-drawer]'); d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      const s = $('[data-drawer-scrim="CartDrawer"]'); if (s) s.classList.add('is-open');
      const b = $('.lm-drawer__body', d); if (b) b.scrollTop = scrollTop;
    }
    initDots(wrap);
    holiday(wrap);
    deliv(wrap);
    loadUpsell();
  };
  const busy = on => { const d = $('[data-cart-drawer]'); if (d) d.classList.toggle('is-busy', on); };
  const cartFetch = async (url, body) => {
    busy(true);
    try {
      const id = cartSectionId();
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Lumelie': '1' }, body: JSON.stringify({ ...body, sections: id ? [id] : [], sections_url: window.location.pathname }) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Er ging iets mis');
      return data;
    } finally { busy(false); }
  };
  const refreshCart = async () => {
    const id = cartSectionId();
    const [cart, html] = await Promise.all([
      fetch(R.cart + '.js').then(r => r.json()),
      id ? fetch(`${window.location.pathname}?section_id=${id}`).then(r => r.text()) : Promise.resolve(null)
    ]);
    updateCounts(cart.item_count);
    if (html) renderCart({ [id]: html });
    return cart;
  };
  /* Truck + confetti on the free-shipping bar, started after the drawer has slid in. */
  const celebrate = () => setTimeout(() => {
    const s = $('[data-cart-drawer] .lm-cart__ship'); if (!s) return;
    s.classList.remove('is-party'); void s.offsetWidth; s.classList.add('is-party');
  }, 320);
  const addToCart = async (items) => {
    try {
      const data = await cartFetch(R.cartAdd + '.js', { items });
      renderCart(data.sections);
      const cart = await fetch(R.cart + '.js').then(r => r.json());
      updateCounts(cart.item_count);
      openDrawer('CartDrawer'); celebrate();
      return true;
    } catch (err) { toast(err.message); return false; }
  };
  L.addToCart = addToCart;
  L.openCart = () => openDrawer('CartDrawer');
  if (isCartPage) { document.documentElement.classList.add('lm-cart-page'); openDrawer('CartDrawer'); }
  L.refreshCart = refreshCart;

  /* Apps (e.g. Kaching Bundles) that add to cart themselves: refresh + open the slide cart afterwards */
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const res = await nativeFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const hdrs = init && init.headers;
      const ours = hdrs && ((hdrs instanceof Headers && hdrs.get('X-Lumelie')) || hdrs['X-Lumelie']);
      if (!ours && res.ok && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && (!init.method || init.method.toUpperCase() === 'POST')) {
        refreshCart().then(() => { if (/\/cart\/add/.test(url)) { openDrawer('CartDrawer'); celebrate(); } });
      }
    } catch (e) {}
    return res;
  };
  document.addEventListener('cart:refresh', () => refreshCart());
  document.addEventListener('kaching:cart:updated', () => refreshCart().then(() => { openDrawer('CartDrawer'); celebrate(); }));

  document.addEventListener('click', async e => {
    const open = e.target.closest('[data-cart-open]');
    if (open) { e.preventDefault(); openDrawer('CartDrawer'); return; }
    const ch = e.target.closest('[data-line-change]');
    if (ch) {
      try {
        const data = await cartFetch(R.cartChange + '.js', { id: ch.dataset.lineChange, quantity: parseInt(ch.dataset.qty, 10) });
        updateCounts(data.item_count); renderCart(data.sections);
      } catch (err) { toast(err.message); refreshCart(); }
      return;
    }
    const add = e.target.closest('[data-add-variant]');
    if (add) { add.classList.add('is-loading'); await addToCart([{ id: parseInt(add.dataset.addVariant, 10), quantity: 1 }]); add.classList.remove('is-loading'); return; }
    const rm = e.target.closest('[data-discount-remove]');
    if (rm) {
      try { const data = await cartFetch(R.cartUpdate + '.js', { discount: '' }); renderCart(data.sections); } catch (err) { toast(err.message); }
    }
  });
  document.addEventListener('submit', async e => {
    const f = e.target.closest('[data-discount-form]'); if (!f) return;
    e.preventDefault();
    const input = $('input', f), code = input.value.trim(); if (!code) return;
    const err = $('[data-discount-error]');
    try {
      const existing = (await fetch(R.cart + '.js').then(r => r.json())).discount_codes || [];
      const codes = existing.map(d => d.code).filter(c => c.toUpperCase() !== code.toUpperCase()).concat([code]).join(',');
      const data = await cartFetch(R.cartUpdate + '.js', { discount: codes });
      const hit = (data.discount_codes || []).find(d => d.code.toUpperCase() === code.toUpperCase());
      if (hit && hit.applicable) { renderCart(data.sections); toast('Kortingscode toegepast'); }
      else {
        await cartFetch(R.cartUpdate + '.js', { discount: existing.map(d => d.code).join(',') });
        if (err) err.hidden = false; input.classList.add('is-error');
      }
    } catch (x) { if (err) err.hidden = false; input.classList.add('is-error'); }
  });
  document.addEventListener('input', e => {
    if (e.target.closest('[data-discount-form]')) { e.target.classList.remove('is-error'); const err = $('[data-discount-error]'); if (err) err.hidden = true; }
  });

  /* Upsell via Shopify recommendations (when no fixed collection is chosen) */
  const loadUpsell = async () => {
    const w = $('[data-cart-upsell]'); if (!w || w.hasAttribute('data-static') || w.dataset.loaded) return;
    const pid = w.dataset.productId; if (!pid) { w.hidden = true; return; }
    w.dataset.loaded = '1';
    try {
      const html = await fetch(`${R.recommendations}?product_id=${pid}&limit=10&section_id=product-recommendations-mini`).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const out = $('[data-upsell-results]', doc);
      const list = $('[data-upsell-list]', w);
      if (out && out.children.length && list) { list.innerHTML = out.innerHTML; initDots(w.parentElement || document); } else w.hidden = true;
    } catch (e) { w.hidden = true; }
  };
  loadUpsell();

  /* Product forms (product page + any form[data-product-form]) */
  document.addEventListener('input', e => {
    const i = e.target.closest('.lm-personal input'); if (!i) return;
    const c = $('[data-char-count]', i.closest('label')); if (c) c.textContent = i.value.length + '/' + i.maxLength;
    const box = i.closest('.lm-personal'); const err = box && $('[data-personal-error]', box);
    if (err && i.value.trim()) { err.hidden = true; i.classList.remove('is-error'); }
  });
  document.addEventListener('submit', async e => {
    const f = e.target.closest('form[data-product-form]'); if (!f) return;
    e.preventDefault();
    const missing = $$(`[data-required-prop][form="${f.id}"]`).find(i => !i.value.trim());
    if (missing) {
      const box = missing.closest('.lm-personal'), err = box && $('[data-personal-error]', box);
      if (err) err.hidden = false; missing.classList.add('is-error');
      missing.scrollIntoView({ behavior: 'smooth', block: 'center' }); missing.focus({ preventScroll: true });
      return;
    }
    const btn = $('[type="submit"]', f); if (btn) btn.classList.add('is-loading');
    const fd = new FormData(f);
    const item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) };
    const props = {}; for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
    if (Object.keys(props).length) item.properties = props;
    await addToCart([item]);
    if (btn) btn.classList.remove('is-loading');
  });

  /* ---------- Quick add ---------- */
  const quick = $('[data-quick-modal]');
  const qt = key => (quick && quick.dataset[key]) || '';
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const quickError = (body, handle, opts, notFound) => {
    body.innerHTML = `<div class="lm-quick__error" role="alert">
      <span class="lm-quick__error-icon" aria-hidden="true">!</span>
      <h2 class="lm-quick__name" tabindex="-1" data-modal-focus>${esc(notFound ? qt('textErrorTitle') : qt('textErrorGeneric'))}</h2>
      ${notFound ? `<p class="lm-muted">${esc(qt('textErrorText'))}</p>` : ''}
      ${opts.wishlist ? `<button type="button" class="lm-quick__remove" data-wish-remove="${esc(handle)}">${esc(qt('textRemove'))}</button>` : ''}
    </div>`;
  };
  /* opts: { wishlist: true } shows the remove button and a wishlist label; opener = element that opened it */
  const openQuick = async (handle, opts = {}, opener) => {
    if (!quick) return;
    const body = $('[data-quick-body]', quick), box = $('[data-modal-box]', quick);
    body.innerHTML = `<div class="lm-quick__loading" tabindex="-1" data-modal-focus>${esc(qt('textLoading') || 'Laden…')}</div>`;
    if (box) box.setAttribute('aria-label', opts.wishlist ? qt('textWishlistLabel') : qt('textLoading'));
    quick.classList.toggle('is-wishlist', !!opts.wishlist);
    openModal(quick, opener);
    try {
      const res = await fetch(`${R.root.replace(/\/$/, '')}/products/${encodeURIComponent(handle)}?section_id=quick-add-content`);
      if (!res.ok) { quickError(body, handle, opts, res.status === 404); focusInModal(quick); return; }
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const c = $('[data-quick-content]', doc);
      if (!c || $('[data-quick-missing]', doc)) { quickError(body, handle, opts, true); focusInModal(quick); return; }
      body.innerHTML = c.innerHTML;
      const title = $('.lm-quick__name', body);
      if (box && title) { box.removeAttribute('aria-label'); box.setAttribute('aria-labelledby', title.id || ''); }
      const rm = $('[data-wish-remove]', body); if (rm) rm.hidden = !opts.wishlist;
      bindVariantPicker(body);
      if (title) { title.setAttribute('data-modal-focus', ''); }
      focusInModal(quick);
    } catch (e) { quickError(body, handle, opts, false); focusInModal(quick); }
  };
  const bindVariantPicker = root => {
    const json = $('[data-quick-variants]', root); if (!json) return;
    const variants = JSON.parse(json.textContent);
    const selects = $$('[data-quick-option]', root);
    const idInput = $('[data-quick-variant]', root), submit = $('[data-quick-submit]', root), price = $('[data-quick-price]', root);
    const update = () => {
      const vals = selects.map(s => s.value);
      const v = variants.find(x => x.options.every((o, i) => o === vals[i]));
      if (!submit) return;
      const lbl = k => submit.dataset[k] || '';
      if (!v) { submit.disabled = true; submit.textContent = lbl('labelUnavailable') || 'Niet beschikbaar'; return; }
      idInput.value = v.id; submit.disabled = !v.available; submit.textContent = v.available ? (lbl('labelAdd') || 'In winkelmand') : (lbl('labelSoldout') || 'Uitverkocht');
      if (price) price.innerHTML = `<span class="price"><strong>${money(v.price)}</strong>${v.compare > v.price ? `<s>${money(v.compare)}</s>` : ''}</span>`;
    };
    selects.forEach(s => s.addEventListener('change', update));
  };
  /* Products with options: go to the product page first (variant choice via Kaching there) */
  document.addEventListener('click', e => {
    const q = e.target.closest('[data-quick-add]'); if (!q) return;
    e.preventDefault();
    window.location.href = `${R.root.replace(/\/$/, '')}/products/${q.dataset.quickAdd}`;
  });
  L.openQuick = openQuick;
  document.addEventListener('click', e => {
    const s = e.target.closest('[data-qty-step]'); if (!s) return;
    const input = $('[data-qty-input]', s.closest('.qty')); if (!input) return;
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(s.dataset.qtyStep, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('submit', async e => {
    const f = e.target.closest('[data-quick-form]'); if (!f) return;
    e.preventDefault();
    const fd = new FormData(f), btn = $('[data-quick-submit]', f);
    btn.classList.add('is-loading');
    const ok = await addToCart([{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1 }]);
    btn.classList.remove('is-loading');
    if (ok) closeModal(quick);
  });

  /* ---------- Wishlist (stored in this browser) ---------- */
  const WK = 'lm-wishlist';
  const wish = () => store.get(WK, []);
  const paintWish = () => {
    const list = wish();
    $$('[data-wish]').forEach(b => { const on = list.includes(b.dataset.wish); b.classList.toggle('is-wished', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    $$('[data-wish-count]').forEach(c => { c.textContent = list.length; c.hidden = list.length === 0; });
    if (typeof L.fitTitles === 'function') L.fitTitles();
  };
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault();
    const list = wish(), h = b.dataset.wish, i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast('Verwijderd van je verlanglijst'); } else { list.push(h); toast('Op je verlanglijst gezet'); }
    store.set(WK, list); paintWish();
    document.dispatchEvent(new CustomEvent('lm:wishlist', { detail: list }));
  });
  paintWish();
  L.wishlist = wish;
  L.paintWish = paintWish;

  /* ---------- Video players (click to play) ---------- */
  document.addEventListener('click', e => {
    const p = e.target.closest('[data-play]'); if (!p) return;
    const box = p.closest('.video-box') || p.parentElement;
    const v = $('video', box);
    if (v) { v.controls = true; v.play(); box.classList.add('is-playing'); return; }
    const tpl = $('template', box);
    if (tpl) { box.appendChild(tpl.content.cloneNode(true)); box.classList.add('is-playing'); }
  });

  /* ---------- Autoplay videos: muted, looped, only while visible ---------- */
  const autoVids = $$('video[data-autoplay]');
  // Poster only when the video gets near the viewport; nothing downloads before that
  const showPoster = v => { if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); };
  const tryPlay = v => { showPoster(v); v.muted = true; v.preload = 'auto'; const p = v.play(); if (p && p.catch) p.catch(() => {}); };
  const inView = v => { const r = v.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth; };
  autoVids.forEach(v => {
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.playsInline = true;
    // Light rendition missing: fall back to the original source once
    const s = v.querySelector('source');
    if (s && v.dataset.fallback) s.addEventListener('error', () => {
      if (v.dataset.fellBack) return;
      v.dataset.fellBack = '1'; s.src = v.dataset.fallback; v.load(); if (inView(v)) tryPlay(v);
    });
    v.addEventListener('canplay', () => { if (inView(v) && v.paused) tryPlay(v); });
  });
  if (autoVids.length && 'IntersectionObserver' in window) {
    const near = new IntersectionObserver(entries => entries.forEach(en => {
      if (en.isIntersecting) { showPoster(en.target); near.unobserve(en.target); }
    }), { rootMargin: '400px 0px' });
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if (en.isIntersecting) tryPlay(en.target); else if (!en.target.paused) en.target.pause();
    }), { threshold: 0.15 });
    autoVids.forEach(v => { near.observe(v); io.observe(v); });
    /* Some phones only allow playback after the first interaction */
    const kick = () => { autoVids.forEach(v => { if (v.paused && inView(v)) tryPlay(v); }); };
    ['touchstart', 'scroll', 'click'].forEach(ev => window.addEventListener(ev, kick, { passive: true, once: true }));
  } else autoVids.forEach(v => { showPoster(v); tryPlay(v); });

  /* ---------- Social comments: like toggle ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-fb-like]'); if (!b) return;
    const on = b.getAttribute('aria-pressed') !== 'true';
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    const c = $('[data-fb-count]', b.closest('.fb-card'));
    if (c) c.textContent = parseInt(c.dataset.base, 10) + (on ? 1 : 0);
  });

  /* ---------- Reviews modal: topic filter + load more ---------- */
  document.addEventListener('click', e => {
    const m = e.target.closest('[data-tp-topic]');
    if (m) {
      const modal = m.closest('[data-modal]');
      const on = m.getAttribute('aria-pressed') !== 'true';
      $$('[data-tp-topic]', modal).forEach(x => x.setAttribute('aria-pressed', 'false'));
      m.setAttribute('aria-pressed', on ? 'true' : 'false');
      modal.dataset.topic = on ? m.dataset.tpTopic : '';
      modal.dataset.shown = 5; paintTp(modal); return;
    }
    const more = e.target.closest('[data-tp-more]');
    if (more) { const modal = more.closest('[data-modal]'); modal.dataset.shown = (parseInt(modal.dataset.shown || 5, 10) + 5); paintTp(modal); return; }
    const u = e.target.closest('[data-tp-useful]');
    if (u) { const on = u.getAttribute('aria-pressed') !== 'true'; u.setAttribute('aria-pressed', on); u.style.color = on ? 'var(--lm-blauw)' : ''; $('span', u).textContent = on ? 'Nuttig (1)' : 'Nuttig'; }
  });
  const paintTp = modal => {
    const topic = modal.dataset.topic || '', shown = parseInt(modal.dataset.shown || 5, 10);
    const list = $$('[data-tp-review]', modal).filter(r => !topic || (r.dataset.topics || '').split(',').map(s => s.trim()).includes(topic));
    $$('[data-tp-review]', modal).forEach(r => { r.hidden = true; });
    list.slice(0, shown).forEach(r => { r.hidden = false; });
    const more = $('[data-tp-more]', modal); if (more) more.hidden = list.length <= shown;
  };
  $$('[data-tp-modal]').forEach(paintTp);

  /* ---------- Gift check ---------- */
  $$('[data-giftcheck]').forEach(gc => {
    const state = { age: gc.dataset.defaultAge, int: gc.dataset.defaultInt, bud: gc.dataset.defaultBud };
    const items = $$('[data-gc-item]', gc);
    const title = $('[data-gc-title]', gc), link = $('[data-gc-link]', gc), list = $('[data-gc-list]', gc), empty = $('[data-gc-empty]', gc);
    const paint = () => {
      $$('[data-gc-opt]', gc).forEach(b => b.setAttribute('aria-pressed', state[b.dataset.gcGroup] === b.dataset.gcOpt ? 'true' : 'false'));
      const bud = $(`[data-gc-group="bud"][data-gc-opt="${state.bud}"]`, gc);
      const min = bud ? parseInt(bud.dataset.min, 10) : 0, max = bud ? parseInt(bud.dataset.max, 10) : 1e9;
      const a = $(`[data-gc-group="age"][data-gc-opt="${state.age}"]`, gc), i = $(`[data-gc-group="int"][data-gc-opt="${state.int}"]`, gc);
      const ageCol = a && a.dataset.url ? (a.dataset.url.split('/collections/')[1] || '').split(/[?#/]/)[0] : '';
      // Budget is a hard filter; age and interest decide the order within it.
      const scored = items.map(el => {
        const ages = (el.dataset.ages || '').split(','), ints = (el.dataset.ints || '').split(','), cols = (el.dataset.cols || '').split(','), p = parseInt(el.dataset.price, 10);
        const ageHit = ages.includes(state.age) || (ageCol && cols.includes(ageCol));
        return { el, sc: (ageHit ? 2 : 0) + (ints.includes(state.int) ? 1 : 0), p };
      }).filter(s => s.p >= min && s.p < max).sort((x, y) => y.sc - x.sc || x.p - y.p);
      items.forEach(el => { el.hidden = true; const best = $('[data-gc-best]', el); if (best) best.hidden = true; });
      scored.slice(0, 3).forEach((s, n) => { s.el.hidden = false; list.appendChild(s.el); if (n === 0 && s.sc === 3) { const best = $('[data-gc-best]', s.el); if (best) best.hidden = false; } });
      if (empty) empty.hidden = items.length > 0;
      const none = $('[data-gc-none]', gc); if (none) none.hidden = !items.length || scored.length > 0;
      if (title && a && i && bud) title.textContent = `Onze tip voor ${a.dataset.label} · ${i.dataset.label} · ${bud.dataset.label.toLowerCase()}`;
      if (link && a) link.href = a.dataset.url || link.href;
    };
    gc.addEventListener('click', e => { const b = e.target.closest('[data-gc-opt]'); if (!b) return; state[b.dataset.gcGroup] = b.dataset.gcOpt; paint(); });
    paint();
  });

  /* ---------- Scratch popup ---------- */
  const scratch = $('[data-scratch]');
  if (scratch && L.scratch && L.scratch.enabled) {
    const SK = 'lm-scratch';
    const st = store.get(SK, { seen: false, claimed: false });
    const tab = $('[data-scratch-tab]');
    const showTab = () => { if (tab) tab.hidden = st.claimed || scratch.classList.contains('is-open'); };
    const canvas = $('[data-scratch-canvas]', scratch);
    let drawn = false;
    const reveal = () => {
      scratch.classList.add('is-revealed');
      if (canvas) { canvas.style.opacity = 0; canvas.style.pointerEvents = 'none'; }
      const h = $('[data-scratch-hint]', scratch); if (h) h.textContent = 'Gefeliciteerd! Vul je e-mailadres in om je korting te claimen.';
    };
    const draw = () => {
      if (drawn || !canvas) return; drawn = true;
      const r = canvas.getBoundingClientRect(), dpr = window.devicePixelRatio || 1;
      canvas.width = r.width * dpr; canvas.height = r.height * dpr;
      const ctx = canvas.getContext('2d'); ctx.scale(dpr, dpr);
      ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--lm-oranje').trim() || '#F07D1A';
      ctx.fillRect(0, 0, r.width, r.height);
      ctx.fillStyle = 'rgba(255,255,255,.18)';
      for (let x = -r.height; x < r.width; x += 14) { ctx.beginPath(); ctx.moveTo(x, r.height); ctx.lineTo(x + r.height, 0); ctx.lineTo(x + r.height + 6, 0); ctx.lineTo(x + 6, r.height); ctx.fill(); }
      ctx.fillStyle = '#fff'; ctx.font = '800 18px Figtree, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('Kras hier', r.width / 2, r.height / 2);
      ctx.globalCompositeOperation = 'destination-out'; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 34;
      let down = false, last = null, moves = 0;
      const pt = e => { const b = canvas.getBoundingClientRect(); return [e.clientX - b.left, e.clientY - b.top]; };
      const check = () => {
        const d = ctx.getImageData(0, 0, canvas.width, canvas.height).data; let clear = 0;
        for (let i = 3; i < d.length; i += 64) if (d[i] === 0) clear++;
        if (clear / (d.length / 64) > 0.45) reveal();
      };
      canvas.addEventListener('pointerdown', e => { down = true; last = pt(e); canvas.setPointerCapture(e.pointerId); ctx.beginPath(); ctx.arc(last[0], last[1], 17, 0, 7); ctx.fill(); });
      canvas.addEventListener('pointermove', e => { if (!down) return; const p = pt(e); ctx.beginPath(); ctx.moveTo(last[0], last[1]); ctx.lineTo(p[0], p[1]); ctx.stroke(); last = p; if (++moves % 8 === 0) check(); });
      canvas.addEventListener('pointerup', () => { down = false; check(); });
    };
    const showClaimed = email => {
      $('[data-scratch-step="1"]', scratch).hidden = true;
      $('[data-scratch-step="2"]', scratch).hidden = false;
      const i = $('[data-scratch-intro]', scratch); if (i) i.textContent = 'Je korting is geclaimd. Gebruik de code bij het afrekenen.';
      const s = $('[data-scratch-sent]', scratch); if (s && email) s.textContent = 'Ook naar ' + email + ' gestuurd';
    };
    const open = () => { openModal(scratch); requestAnimationFrame(draw); showTab(); };
    if (st.claimed) showClaimed(st.email);
    if (tab) tab.addEventListener('click', open);
    scratch.addEventListener('lm:closed', () => { st.seen = true; store.set(SK, st); showTab(); });
    const rv = $('[data-scratch-reveal]', scratch); if (rv) rv.addEventListener('click', reveal);
    const form = $('[data-scratch-form]', scratch) || $('form', scratch);
    if (form) form.addEventListener('submit', async e => {
      e.preventDefault();
      const email = (form.querySelector('[type="email"]') || {}).value || '';
      const err = $('[data-scratch-error]', scratch);
      if (!/^\S+@\S+\.\S+$/.test(email)) { if (err) err.hidden = false; return; }
      if (err) err.hidden = true;
      try {
        const res = await fetch(form.action, { method: 'POST', body: new FormData(form) });
        if (res.url && /challenge/.test(res.url)) { form.submit(); return; }
      } catch (x) { /* still show code */ }
      st.claimed = true; st.email = email; store.set(SK, st);
      showClaimed(email);
    });
    const copy = $('[data-scratch-copy]', scratch);
    if (copy) copy.addEventListener('click', () => { try { navigator.clipboard.writeText(L.scratch.code); } catch (e) {} copy.textContent = 'Gekopieerd'; });
    if (!st.seen && !st.claimed && !L.isDesignMode) {
      setTimeout(() => { if (!document.body.classList.contains('lm-locked')) open(); else showTab(); }, L.scratch.delay || 3000);
    } else showTab();
  }

  /* ---------- Header height (for sticky toolbars) ---------- */
  const hdr = $('.lm-header-section');
  const setHH = () => { if (hdr) document.documentElement.style.setProperty('--lm-header-h', hdr.offsetHeight + 'px'); };
  let hhW = innerWidth;
  setHH(); window.addEventListener('resize', debounce(() => { if (innerWidth !== hhW) { hhW = innerWidth; setHH(); } }, 100));

  /* ---------- Collection: filters, sort, load more ---------- */
  let collCtrl;
  const collRoot = () => $('[data-collection-root]');
  const loadCollection = async (url, push = true) => {
    const root = collRoot(); if (!root) return;
    const sheetOpen = $('[data-filters]', root) && $('[data-filters]', root).classList.contains('is-open');
    const openAccs = $$('.lm-filter', root).map(a => a.classList.contains('is-open'));
    collCtrl && collCtrl.abort(); collCtrl = new AbortController();
    root.classList.add('is-loading');
    try {
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', root.dataset.sectionId);
      const html = await fetch(u, { signal: collCtrl.signal }).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-collection-root]', doc); if (!fresh) return;
      root.innerHTML = fresh.innerHTML;
      $$('.lm-filter', root).forEach((a, i) => { if (openAccs[i] !== undefined) a.classList.toggle('is-open', openAccs[i]); });
      if (sheetOpen) $('[data-filters]', root).classList.add('is-open'), $('[data-filters-scrim]', root).classList.add('is-open');
      if (push) { u.searchParams.delete('section_id'); history.pushState({ lmColl: true }, '', u.pathname + u.search); }
      paintWish();
    } catch (e) { /* aborted */ } finally { root.classList.remove('is-loading'); }
  };
  const formUrl = form => {
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form).entries()) if (v !== '') params.append(k, v);
    return form.getAttribute('action') + (params.toString() ? '?' + params : '');
  };
  const submitFilters = debounce(form => loadCollection(formUrl(form)), 450);
  document.addEventListener('change', e => {
    const i = e.target.closest('[data-filter-input]'); if (!i) return;
    const form = i.closest('[data-filter-form]');
    if (i.hasAttribute('data-debounce')) submitFilters(form); else loadCollection(formUrl(form));
  });
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-filter-form]'); if (!f) return;
    e.preventDefault(); loadCollection(formUrl(f));
  });
  document.addEventListener('click', async e => {
    const l = e.target.closest('[data-filter-link]');
    if (l) { e.preventDefault(); loadCollection(l.href); return; }
    const o = e.target.closest('[data-filters-open]');
    if (o) { const r = collRoot(); $('[data-filters]', r).classList.add('is-open'); $('[data-filters-scrim]', r).classList.add('is-open'); lock('filters', true); return; }
    const c = e.target.closest('[data-filters-close], [data-filters-scrim]');
    if (c) { const r = collRoot(); $('[data-filters]', r).classList.remove('is-open'); $('[data-filters-scrim]', r).classList.remove('is-open'); lock('filters', false); return; }
    const more = e.target.closest('[data-load-next]');
    if (more) {
      e.preventDefault();
      const root = collRoot(), grid = $('[data-product-grid]', root); if (!grid) return;
      more.classList.add('is-loading');
      try {
        const u = new URL(more.href, location.origin); u.searchParams.set('section_id', root.dataset.sectionId);
        const doc = new DOMParser().parseFromString(await fetch(u).then(r => r.text()), 'text/html');
        // importNode: create the cards in this document, so WebKit starts loading their (lazy) images
        $$('[data-product-grid] > .pcard', doc).forEach(card => grid.appendChild(document.importNode(card, true)));
        const nl = $('[data-load-more]', doc), cur = $('[data-load-more]', root);
        if (nl && cur) cur.replaceWith(nl); else if (cur) cur.remove();
        paintWish();
      } finally { more.classList.remove('is-loading'); }
    }
  });
  window.addEventListener('popstate', () => { if (collRoot()) loadCollection(location.href, false); });

  // Card image failed (flaky mobile / in-app browser connection): retry once, then show the placeholder instead of a broken icon + alt text
  document.addEventListener('error', e => {
    const img = e.target;
    if (!(img instanceof HTMLImageElement) || !img.closest('.pcard__media')) return;
    if (!img.dataset.retried) {
      img.dataset.retried = '1';
      const src = img.getAttribute('src'), set = img.getAttribute('srcset');
      setTimeout(() => { img.removeAttribute('srcset'); img.src = src + (src.includes('?') ? '&' : '?') + 'r=1'; if (set) img.setAttribute('srcset', set.replace(/(\S+?)(\s+\d+w)/g, '$1&r=1$2')); }, 600);
    } else img.classList.add('is-broken');
  }, true);

  /* ---------- Discount code banner: click to copy ---------- */
  const copyText = async txt => {
    try { await navigator.clipboard.writeText(txt); return true; } catch (e) {
      const t = document.createElement('textarea'); t.value = txt; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select(); let ok = false; try { ok = document.execCommand('copy'); } catch (err) {} t.remove(); return ok;
    }
  };
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-dcb-copy]'); if (!b) return;
    e.preventDefault();
    const code = b.dataset.dcbCopy, box = b.closest('[data-dcb]'), status = box && $('[data-dcb-status]', box);
    const ok = await copyText(code);
    if (!ok) { const v = $('[data-dcb-value]', b); if (v) { const r = document.createRange(); r.selectNodeContents(v); const s = getSelection(); s.removeAllRanges(); s.addRange(r); } return; }
    b.classList.add('is-copied');
    if (status) status.textContent = `Kortingscode ${code} gekopieerd`;
    clearTimeout(b._dcbT); b._dcbT = setTimeout(() => { b.classList.remove('is-copied'); if (status) status.textContent = ''; }, 2000);
  });

  /* ---------- Product page: gallery, variants, sticky buy bar ---------- */
  $$('[data-gallery]').forEach(g => {
    const track = $('[data-gallery-track]', g), thumbs = $$('[data-gallery-thumb]', g), count = $('[data-gallery-count]', g);
    if (!track) return;
    const n = track.children.length;
    const idx = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const go = i => { i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
    const strip = $('.lm-gallery__thumbs', g);
    const paint = () => {
      const i = idx(); thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i)); if (count) count.textContent = (i + 1) + ' / ' + n;
      const t = thumbs[i];
      if (strip && t) {
        const l = t.offsetLeft - strip.offsetLeft, r = l + t.offsetWidth;
        if (l < strip.scrollLeft) strip.scrollTo({ left: l, behavior: 'smooth' });
        else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: r - strip.clientWidth, behavior: 'smooth' });
      }
    };
    track.addEventListener('scroll', debounce(paint, 60), { passive: true });
    g.addEventListener('click', e => {
      if (e.target.closest('[data-gallery-prev]')) go(idx() - 1);
      else if (e.target.closest('[data-gallery-next]')) go(idx() + 1);
      else { const t = e.target.closest('[data-gallery-thumb]'); if (t) go(parseInt(t.dataset.galleryThumb, 10)); }
    });
    g.lmGo = mediaId => { const s = $$('.lm-gallery__slide', track).findIndex(x => x.dataset.mediaId == mediaId); if (s > -1) go(s); };
  });

  $$('[data-product-section]').forEach(sec => {
    const json = $('[data-variants]', sec); if (!json) return;
    const variants = JSON.parse(json.textContent);
    const form = $('form[data-product-form]', sec); if (!form) return;
    const idInput = $('[data-variant-id]', form), atc = $('[data-atc]', form);
    const gallery = $('[data-gallery]', sec);
    const sticky = $('[data-sticky-buy]');
    const update = () => {
      const opts = [0, 1, 2].map(i => { const c = $(`select[data-variant-option="${i}"]`, form) || $(`[data-variant-option="${i}"]:checked`, form); return c ? c.value : null; }).filter(x => x !== null);
      const v = variants.find(x => x.options.every((o, i) => o === opts[i]));
      $$('fieldset.lm-variant', form).forEach(fs => { const inp = $('[data-variant-option]:checked', fs), l = $('[data-option-value]', fs); if (l && inp) l.textContent = inp.value; });
      if (!v) { atc.disabled = true; atc.textContent = 'Niet beschikbaar'; return; }
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'In winkelmand' : 'Uitverkocht';
      const pr = $('[data-pdp-price]', sec);
      if (pr) pr.innerHTML = `<strong>${money(v.price)}</strong>` + (v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s><span class="lm-save">Je bespaart ${money(v.compare_at_price - v.price)}</span>` : '');
      const sp = sticky && $('[data-sticky-price]', sticky);
      if (sp) sp.innerHTML = `<span class="price price--sm"><strong>${money(v.price)}</strong>${v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s>` : ''}</span>`;
      const sa = sticky && $('[data-sticky-atc]', sticky); if (sa) sa.disabled = !v.available;
      if (v.featured_media && gallery && gallery.lmGo) gallery.lmGo(v.featured_media.id);
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    };
    form.addEventListener('change', e => { if (e.target.matches('[data-variant-option]')) update(); });

    if (sticky) {
      const anchor = $('[data-atc-anchor]', sec);
      const sa = $('[data-sticky-atc]', sticky);
      if (sa) sa.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })));
      /* Kaching Bundles: the sticky price follows the selected bundle (e.g. "2 stuks"), not the single-item price. */
      /* Kaching renders its widget after this runs, so look it up on demand and listen on the whole form. */
      const sp = $('[data-sticky-price]', sticky);
      if (sp) {
        const txt = (bar, cls) => { const e = bar && $(cls, bar); return e ? esc(e.textContent.trim()) : ''; };
        let last = '';
        const syncBundle = () => {
          const r = $('kaching-bundle input[type="radio"]:checked', form), bar = r && r.closest('.kaching-bundles__bar');
          const price = txt(bar, '.kaching-bundles__bar-price'), full = txt(bar, '.kaching-bundles__bar-full-price');
          const html = price ? `<span class="price price--sm"><strong>${price}</strong>${full && full !== price ? `<s>${full}</s>` : ''}</span>` : '';
          if (html && html !== last) { sp.innerHTML = html; last = html; }
        };
        let raf = 0; const queue = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(syncBundle); };
        form.addEventListener('change', queue);
        form.addEventListener('click', queue);
        new MutationObserver(queue).observe(form, { childList: true, subtree: true, characterData: true });
      }
      if (anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => {
          /* Shown whenever the real ATC is off-screen, before reaching it too. */
          const show = !e.isIntersecting;
          document.documentElement.style.setProperty('--lm-sticky-h', Math.ceil(sticky.getBoundingClientRect().height) + 'px');
          sticky.classList.toggle('is-shown', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('has-sticky-buy', show);
        }).observe(anchor);
      }
    }
  });

  deliv();

  /* ATC nudge: a short wiggle after 7s without interaction, then at most twice more (15s apart).
     Stops for good on any click in the buy form; skipped with reduced motion. */
  const nudgeForm = $('form[action*="/cart/add"] [data-atc]')?.form;
  if (nudgeForm && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let left = 3, timer;
    const inView = el => { const r = el.getBoundingClientRect(); return r.width && r.bottom > 0 && r.top < innerHeight; };
    const nudge = () => {
      if (document.hidden) { timer = setTimeout(nudge, 3000); return; }
      const sticky = $('.lm-sticky-buy.is-shown [data-sticky-atc]');
      const btn = [$('[data-atc]', nudgeForm), sticky].find(b => b && !b.disabled && inView(b));
      if (btn) { btn.classList.remove('is-nudge'); void btn.offsetWidth; btn.classList.add('is-nudge'); left--; }
      if (left > 0) timer = setTimeout(nudge, btn ? 15000 : 4000);
    };
    const stop = () => { clearTimeout(timer); left = 0; };
    timer = setTimeout(nudge, 7000);
    nudgeForm.addEventListener('click', stop, { once: true });
    nudgeForm.addEventListener('change', stop, { once: true });
    $('[data-sticky-atc]')?.addEventListener('click', stop, { once: true });
    document.addEventListener('animationend', e => { if (e.animationName === 'lm-nudge') e.target.classList.remove('is-nudge'); });
  }

  /* Lazy product recommendations */
  $$('[data-recommendations]').forEach(async el => {
    if (el.children.length) return;
    try {
      const doc = new DOMParser().parseFromString(await fetch(el.dataset.url).then(r => r.text()), 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.children.length) { el.innerHTML = fresh.innerHTML; paintWish(); }
    } catch (e) {}
  });

  /* ---------- Wishlist page ---------- */
  const wg = $('[data-wishlist-grid]');
  const wroot = $('[data-wishlist]');
  const params = new URLSearchParams(location.search);
  const sharedList = (params.get('lijst') || '').split(',').map(s => s.trim()).filter(Boolean);
  const sharedName = (params.get('voor') || '').slice(0, 20);
  const isShared = sharedList.length > 0;
  const shareUrl = name => {
    const u = new URL(location.origin + location.pathname);
    u.searchParams.set('lijst', wish().join(','));
    if (name) u.searchParams.set('voor', name);
    return u.toString();
  };
  const paintShare = () => {
    if (!wroot) return;
    const name = ($('[data-wish-name]', wroot) || {}).value || '';
    const msg = (wroot.dataset.shareMessage || 'Kijk, dit staat op het verlanglijstje:') + (name ? ` (${name})` : '');
    const wa = $('[data-wish-whatsapp]', wroot);
    if (wa) wa.href = 'https://wa.me/?text=' + encodeURIComponent(msg + ' ' + shareUrl(name.trim()));
  };
  const renderWishlist = async () => {
    if (!wg) return;
    const list = isShared ? sharedList : wish(), empty = $('[data-wishlist-empty]');
    if (empty) empty.hidden = list.length > 0;
    const bar = $('[data-wish-bar]'), share = $('[data-wish-share]');
    if (bar) bar.hidden = list.length === 0;
    if (share) share.hidden = isShared || list.length === 0;
    const base = R.root.replace(/\/$/, '');
    const cards = await Promise.all(list.map(h => fetch(`${base}/products/${encodeURIComponent(h)}?section_id=product-card-ajax`).then(r => r.ok ? r.text() : '').catch(() => '')));
    wg.innerHTML = '';
    cards.forEach(html => { if (!html) return; const c = $('[data-card-ajax] > .pcard', new DOMParser().parseFromString(html, 'text/html')); if (c) wg.appendChild(c); });
    const shown = $$('.pcard', wg);
    const total = shown.reduce((n, c) => n + (parseInt(c.dataset.price, 10) || 0), 0);
    const ct = $('[data-wish-count-text]'); if (ct) ct.textContent = shown.length === 1 ? '1 cadeau' : `${shown.length} cadeaus`;
    const tt = $('[data-wish-total]'); if (tt) tt.textContent = money(total);
    const all = $('[data-wish-add-all]'); if (all) all.hidden = !shown.some(c => c.dataset.simple === '1');
    if (bar) bar.hidden = shown.length === 0;
    paintWish(); paintShare();
  };
  if (wroot && isShared) {
    const t = $('[data-wish-title]', wroot); if (t) t.textContent = sharedName ? `Verlanglijst van ${sharedName}` : 'Een verlanglijst voor jou';
    const e = $('[data-wish-eyebrow]', wroot); if (e) e.textContent = 'Gedeeld met jou';
    const i = $('[data-wish-intro]', wroot); if (i) i.hidden = true;
    const sb = $('[data-wish-shared]', wroot); if (sb) sb.hidden = false;
    const st = $('[data-wish-shared-title]', wroot); if (st) st.textContent = sharedName ? `${sharedName} wenst zich deze cadeaus` : 'Deze cadeaus staan op het lijstje';
  }
  renderWishlist();
  document.addEventListener('lm:wishlist', () => { if (wg && !isShared) setTimeout(renderWishlist, 300); });
  /* Wishlist product modal: clicking a product (photo, title or button link) opens the product modal */
  if (wg) {
    wg.addEventListener('click', e => {
      const a = e.target.closest('a[href]'); if (!a || !wg.contains(a)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      const card = a.closest('.pcard'); if (!card || !card.dataset.handle) return;
      e.preventDefault();
      openQuick(card.dataset.handle, { wishlist: !isShared }, a);
    });
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-wish-remove]'); if (!b) return;
    const h = b.dataset.wishRemove;
    const list = wish().filter(x => x !== h); store.set(WK, list);
    if (wg) $$('.pcard', wg).filter(c => c.dataset.handle === h).forEach(c => c.remove());
    if (quick && quick._opener && !quick._opener.isConnected) quick._opener = $('[data-wishlist] h1') || null;
    closeModal(quick);
    paintWish(); toast(qt('textRemoved') || 'Verwijderd uit je verlanglijst');
    if (wg) renderWishlist();
  });
  if (wroot) {
    wroot.addEventListener('input', e => { if (e.target.matches('[data-wish-name]')) paintShare(); });
    wroot.addEventListener('click', async e => {
      const copy = e.target.closest('[data-wish-copy]');
      if (copy) {
        const url = shareUrl((($('[data-wish-name]', wroot) || {}).value || '').trim());
        if (navigator.share && isMobile()) { try { await navigator.share({ title: document.title, url }); return; } catch (x) {} }
        try { await navigator.clipboard.writeText(url); } catch (x) {}
        const s = $('span', copy); if (s) { s.textContent = 'Link gekopieerd!'; setTimeout(() => { s.textContent = 'Kopieer link'; }, 2200); }
        toast('Link gekopieerd, plak hem in een bericht');
        return;
      }
      const all = e.target.closest('[data-wish-add-all]');
      if (all) {
        const items = $$('.pcard', wg).filter(c => c.dataset.simple === '1').map(c => ({ id: parseInt(c.dataset.variant, 10), quantity: 1 }));
        if (!items.length) return;
        all.classList.add('is-loading'); await addToCart(items); all.classList.remove('is-loading');
        return;
      }
      if (e.target.closest('[data-wish-save-shared]')) {
        const list = wish(); sharedList.forEach(h => { if (!list.includes(h)) list.push(h); });
        store.set(WK, list); paintWish(); toast('Bewaard in je eigen verlanglijst');
      }
    });
  }

  /* ---------- One-line product titles: shrink to fit instead of truncating ---------- */
  // Batched: reset all, measure all (one layout), then write all. Text width scales with font size, so one measurement is enough.
  // Social proof line under the buy button: shrink the font (min 10px) until it fits on one line
  const fitProof = (root = document) => {
    root.querySelectorAll('.lm-proof__text').forEach(el => {
      el.style.fontSize = '';
      const fs = parseFloat(getComputedStyle(el).fontSize), sw = el.scrollWidth, cw = el.clientWidth;
      if (cw && sw > cw + 1) el.style.fontSize = Math.max(10, Math.floor(fs * cw / sw * 2) / 2) + 'px';
    });
  };
  const fitTitles = (root = document) => {
    fitProof(root);
    const els = $$('.pcard--one-line .pcard__name', root); if (!els.length) return;
    els.forEach(el => { el.classList.remove('is-wrapped'); el.style.fontSize = ''; });
    const m = els.map(el => [parseFloat(getComputedStyle(el).fontSize), el.scrollWidth, el.clientWidth]);
    els.forEach((el, i) => {
      const [fs, sw, cw] = m[i]; if (!cw || sw <= cw + 1) return;
      const size = Math.floor(fs * cw / sw * 2) / 2;
      if (size >= 10) el.style.fontSize = size + 'px'; else { el.style.fontSize = '10px'; el.classList.add('is-wrapped'); }
    });
  };
  L.fitTitles = fitTitles;
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fitTitles()); else fitTitles();
  // Only when the width changes: on phones the toolbar showing/hiding while scrolling fires height-only resizes
  let fitW = innerWidth;
  window.addEventListener('resize', debounce(() => { if (innerWidth !== fitW) { fitW = innerWidth; fitTitles(); } }, 150));

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', e => { initDots(e.target); paintWish(); fitProof(e.target); });
})();
